// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskTagsEditor_wrapper__jXGK6 {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}

.TaskTagsEditor_tags__bWQms {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.TaskTagsEditor_tag__gveZs {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  min-height: 26px;
  padding: 3px 8px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  color: #162033;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.TaskTagsEditor_tag__gveZs button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.1);
  color: #162033;
  cursor: pointer;
}

.TaskTagsEditor_tag__gveZs button:hover {
  background: rgba(15, 23, 42, 0.18);
}

.TaskTagsEditor_placeholder__gNho2 {
  color: #667085;
}

.TaskTagsEditor_dropdown__Sybyq {
  display: grid;
  gap: 10px;
  width: min(320px, 100vw - 40px);
}

.TaskTagsEditor_palette__usXVq {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.TaskTagsEditor_color__szbm6,
.TaskTagsEditor_colorActive__jGIM7 {
  width: 28px;
  height: 28px;
  border: 1px solid rgba(15, 23, 42, 0.16);
  border-radius: 8px;
  cursor: pointer;
}

.TaskTagsEditor_colorActive__jGIM7 {
  outline: 2px solid #1677ff;
  outline-offset: 1px;
}

.TaskTagsEditor_catalog__PeIBp {
  display: grid;
  gap: 6px;
  max-height: 210px;
  overflow: auto;
}

.TaskTagsEditor_option__QSBVf {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.TaskTagsEditor_option__QSBVf span {
  display: inline-flex;
  max-width: 100%;
  min-height: 28px;
  padding: 5px 9px;
  border-radius: 8px;
  color: #162033;
  font-size: 13px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.TaskTagsEditor_option__QSBVf:hover span {
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.14);
}

.TaskTagsEditor_empty__2y9rh {
  padding: 8px 0;
  color: #667085;
  font-size: 13px;
}

.TaskTagsEditor_popover__GbjND .ant-popover-inner {
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/Components/TaskTagsEditor/TaskTagsEditor.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,iCAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,+BAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AACF;;AAEA;;EAEE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,2BAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,8CAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  min-width: 0;\n}\n\n.tags {\n  display: flex;\n  flex: 1 1 auto;\n  flex-wrap: wrap;\n  gap: 6px;\n  min-width: 0;\n}\n\n.tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 100%;\n  min-height: 26px;\n  padding: 3px 8px;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  border-radius: 8px;\n  color: #162033;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n}\n\n.tag button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: rgba(15, 23, 42, 0.1);\n  color: #162033;\n  cursor: pointer;\n}\n\n.tag button:hover {\n  background: rgba(15, 23, 42, 0.18);\n}\n\n.placeholder {\n  color: #667085;\n}\n\n.dropdown {\n  display: grid;\n  gap: 10px;\n  width: min(320px, calc(100vw - 40px));\n}\n\n.palette {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.color,\n.colorActive {\n  width: 28px;\n  height: 28px;\n  border: 1px solid rgba(15, 23, 42, 0.16);\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.colorActive {\n  outline: 2px solid #1677ff;\n  outline-offset: 1px;\n}\n\n.catalog {\n  display: grid;\n  gap: 6px;\n  max-height: 210px;\n  overflow: auto;\n}\n\n.option {\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n}\n\n.option span {\n  display: inline-flex;\n  max-width: 100%;\n  min-height: 28px;\n  padding: 5px 9px;\n  border-radius: 8px;\n  color: #162033;\n  font-size: 13px;\n  font-weight: 800;\n  overflow-wrap: anywhere;\n}\n\n.option:hover span {\n  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.14);\n}\n\n.empty {\n  padding: 8px 0;\n  color: #667085;\n  font-size: 13px;\n}\n\n.popover :global(.ant-popover-inner) {\n  border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `TaskTagsEditor_wrapper__jXGK6`,
	"tags": `TaskTagsEditor_tags__bWQms`,
	"tag": `TaskTagsEditor_tag__gveZs`,
	"placeholder": `TaskTagsEditor_placeholder__gNho2`,
	"dropdown": `TaskTagsEditor_dropdown__Sybyq`,
	"palette": `TaskTagsEditor_palette__usXVq`,
	"color": `TaskTagsEditor_color__szbm6`,
	"colorActive": `TaskTagsEditor_colorActive__jGIM7`,
	"catalog": `TaskTagsEditor_catalog__PeIBp`,
	"option": `TaskTagsEditor_option__QSBVf`,
	"empty": `TaskTagsEditor_empty__2y9rh`,
	"popover": `TaskTagsEditor_popover__GbjND`
};
export default ___CSS_LOADER_EXPORT___;
